<div class="SupportingDocumentation__FileUpload">
  <file-uploader
    [restrictions]="config?.restriction"
    [showCloseIcon]="config?.showCloseIcon"
    [disabled]="disabled"
    [errorMessageConfig]="config?.errorMessage"
    [config]="config"
    [fileAttachment]="documentContext"
    (fileUploaded)="fileUploaded($event)"
    (fileRemoved)="removeFile($event)"
    [progress]="claimSubmissionService.uploadProgress$ | async"
    [uploadErrorMessage]="claimSubmissionService.uploadError | async"
    data-test-id="calimSubmissionFileUploader"
  >
  </file-uploader>
</div>
